/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React, { createContext, useContext, ReactNode } from 'react';
import { ThemeTokens } from './types';
import { defaultTheme } from './themes/default';
import { christmasTheme } from './themes/christmas';

const THEMES: Record<string, ThemeTokens> = {
  default: defaultTheme,
  christmas: christmasTheme,
};

export const getTheme = (): ThemeTokens => {
  const themeName = process.env.REACT_APP_THEME || 'default';
  return THEMES[themeName] || defaultTheme;
};

const ThemeContext = createContext<ThemeTokens>(getTheme());

export const useTheme = () => useContext(ThemeContext);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const theme = getTheme();

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};
